import { portalPaths, UrlParams } from '@provision/portal-routes';
import { matchPath, useLocation, useParams } from 'react-router-dom';
import { useScreenDimensions } from 'src/utils/system';

/**
 * Screens whose own pane headers carry the phone nav hamburger instead of the global top bar:
 * custom-view lists, an open conversation inside a list, and a conversation's full page.
 */
const PANE_HEADER_NAV_PATHS = [
  portalPaths.entity.selected(UrlParams.entityName, UrlParams.customViewId),
  portalPaths.entity.selected('conversations', UrlParams.customViewId, UrlParams.recordId),
  portalPaths.conversation.full(UrlParams.recordId),
];

const withoutPartnerPrefix = (pathname: string, partnerPrefix?: string) =>
  partnerPrefix && pathname.startsWith(`/${partnerPrefix}/`)
    ? pathname.slice(partnerPrefix.length + 1)
    : pathname;

export const isPaneHeaderNavPath = (pathname: string, partnerPrefix?: string) => {
  const path = withoutPartnerPrefix(pathname, partnerPrefix);
  return PANE_HEADER_NAV_PATHS.some((pattern) => matchPath({ path: pattern }, path) !== null);
};

/**
 * True on a phone when the current screen puts the nav hamburger into its pane header, which
 * also means the global `MobileNavbar` top bar is not rendered. Everything that either shows
 * the hamburger or compensates for the missing bar reads this one value.
 */
export const usePhoneNavInPaneHeader = () => {
  const { isMobile } = useScreenDimensions();
  const { pathname } = useLocation();
  const { friendlyPartnerId } = useParams();

  return isMobile && isPaneHeaderNavPath(pathname, friendlyPartnerId);
};
